// extracted by mini-css-extract-plugin
export default {"wrap":"uF-z","subtitle":"vF-z","contentWrap":"wF-z","imgWrap":"xF-z","heading":"yF-z","copy":"zF-z"};